import React from 'react'


export default function Fail() {

    return (
        <>
            <h3 className='medium-header'>Virhe</h3>
            <div className="link-block">
                <a href={process.env.REACT_APP_ADDRESS}>Palaa takaisin</a>
            </div>
        </>
    )
}
